import React, { useContext } from "react";
import { SubscriptionDetailContext } from "../../../context/SubscriptionDetailContext";
import * as styles from "./styles.module.scss";
import { messages } from "../messages";
import { Link, Title } from "@yoast/ui-library";
import { FormattedMessage } from "react-intl";
import ArrowDownTrayIcon from "@heroicons/react/20/solid/ArrowDownTrayIcon";
import { ExternalLink } from "../../ExternalLink";

/**
 * A list of included plugins in the subscription
 * @returns {Element} The included plugins.
 * @constructor
 */
export const IncludedPlugins = ( { withInstallGuide = false } ) => {
	const { subscription, request: { isFirstLoad } } = useContext( SubscriptionDetailContext );

	if ( isFirstLoad || subscription.included.inSelf.plugins.length === 0 ) {
		return <></>;
	}

	return <section className={ styles.includedPlugins }>
		<Title as={ "p" } size={ "5" }>
			<FormattedMessage { ...messages.productsTitle } />
		</Title>
		<ul className={ styles.pluginList }>
			{ subscription.included.inSelf.plugins.map( plugin => {
				return <li key={ plugin.name }>
					<div>
						<span>{ plugin.name }</span>
						{ plugin.downloadUrl &&
							<Link
								href={ plugin.downloadUrl }
								size="small"
								className={ styles.download }
							>
								<ArrowDownTrayIcon />
								<FormattedMessage { ...messages.downloadLinkText } />
							</Link>
						}
					</div>
				</li>;
			} ) }
		</ul>
		{ withInstallGuide && <>
			<hr />
			<p>
				<ExternalLink href={ "https://yoa.st/myyoast-installation" }>
					<FormattedMessage { ...messages.installationGuides } />
				</ExternalLink>
			</p>
		</> }
	</section>;
};
